import { t } from "i18next";

import { setCurrentFloorID } from "@/features/cartography/cartographySlice";
import { resetAllChanges } from "@/features/editor/editorSlice";
import {
  selectMapViewState,
  setFollowUser,
  setMapViewState,
} from "@/features/map/mapSlice";
import { AppMessageLevel, addMessage } from "../app/appSlice";

import store from "@/app/store";
import {
  selectActiveOverlayFeatures,
  selectEditorHasAnyChange,
} from "@/features/editor/editorSlice.selectors";
import type { GeofenceGeojsonProperties } from "@/libs/models/geofence";
import { OverlayFeatureTypes } from "./types";

export const promptUserWithUnsavedEditorChanges = (message?: string) => {
  // If no unsaved changes, return true
  if (!selectEditorHasAnyChange(store.getState())) {
    return true;
  }

  // Prompt the user to ask how to proceed
  if (
    confirm(message || t("dialogs.unsaved_changes.message", { ns: "editor" }))
  ) {
    store.dispatch(resetAllChanges());
    return true;
  } else {
    return false;
  }
};

export const copyToClipboard = (content: any, successMessage: string) => {
  try {
    navigator.clipboard.writeText(
      typeof content === "string" ? content : JSON.stringify(content, null, 2),
    );
    store.dispatch(
      addMessage({
        id: "copy_to_clipboard",
        level: AppMessageLevel.SUCCESS,
        message: successMessage,
      }),
    );
  } catch (_e) {
    store.dispatch(
      addMessage({
        id: "copy_to_clipboard",
        level: AppMessageLevel.ERROR,
        message: "Could not copy to clipboard",
      }),
    );
  }
};

export const centerOverlayFeature = (
  featureId: string,
  increaseZoom = false,
) => {
  const overlayFeatures = selectActiveOverlayFeatures(store.getState());
  const mapViewState = selectMapViewState(store.getState());

  const feature = overlayFeatures[featureId];
  if (!feature) return;

  store.dispatch(setFollowUser(false));

  if (feature.properties.floorId) {
    store.dispatch(setCurrentFloorID(feature.properties.floorId));
  }

  if (
    feature.properties.type == OverlayFeatureTypes.geofence &&
    feature.properties.center
  ) {
    store.dispatch(
      setMapViewState({
        ...mapViewState,
        latitude: (feature.properties as GeofenceGeojsonProperties).center[1],
        longitude: (feature.properties as GeofenceGeojsonProperties).center[0],
        transitionDuration: 1000,
        zoom: mapViewState.zoom + (increaseZoom ? 1 : 0),
      }),
    );
  } else if (feature.geometry.type == "Point") {
    store.dispatch(
      setMapViewState({
        ...mapViewState,
        latitude: feature.geometry.coordinates[1],
        longitude: feature.geometry.coordinates[0],
        transitionDuration: 1000,
        zoom: mapViewState.zoom + (increaseZoom ? 1 : 0),
      }),
    );
  } else {
    // TODO center map based on the centroid of the shape if needed for new feature types
  }
};
